
webpack.register(
    'components/video-player-youtube/video-player-youtube',
    function() {
        return import('components/video-player-youtube/video-player-youtube');
    },
    true
);